import { render, staticRenderFns } from "./CdrDettaglio.vue?vue&type=template&id=2880e0dc&"
import script from "./CdrDettaglio.vue?vue&type=script&lang=ts&"
export * from "./CdrDettaglio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports